import { useForm, FormProvider } from 'react-hook-form'
import { Input, Text, Button, Stack, Link } from '@chakra-ui/react'

import { Navbar, Footer } from 'modules/common/components'

import { LoginGovBr } from './login-govbr';

const Form = () => {
  const methods = useForm({
    mode: 'onChange',
  })

  const onSubmit = (values) => {
    console.log(values)
  }

  return (
    <Stack w="full" spacing={6}>
      <Text 
        bgGradient="linear(to-r, esmeralda.100, marinho.100)" 
        bgClip='text'
        fontSize="4xl"
        fontWeight="semibold"
      >
        Acesso login
      </Text>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Stack px={6} py={8} spacing={6} border="2px" borderColor="gray.80">
            <Input
              name='cpf'
              type='number'
              placeholder='CPF'
              maxLength={11}
              aria-label='Informe seu cpf'
              {...methods.register('cpf')}
            />
            <Input
              name='password'
              type='password'
              placeholder='Senha'
              aria-label='Informe sua senha'
              {...methods.register('password')}
            />
            <Stack direction={['column', 'row']} alignItems="center" justify="space-between">
              <Link>Esqueci minha senha</Link>
              <Button type="submit" variant="default">Acessar</Button>
            </Stack>
            <Stack direction={['column', 'row']} justify="center">
              <Text color="gray.900">Não tem acesso ainda?</Text>
              <Link>Solicitar acesso</Link>
            </Stack>
          </Stack>
        </form>
      </FormProvider>
    </Stack>
  )
}

const Login = () => {
  return (
    <>
      <Navbar />
      <Stack 
        w="full" 
        my={10} 
        px={32} 
        spacing={[12, 44]} 
        direction={['column', 'row']}
        justifyContent="space-between"
      >
        <Form />
        <LoginGovBr />
      </Stack>
      <Footer />
    </>
  )
}

export default Login
